<template>
  <ul class="pagination">
    <li v-for="(num, index) in rangeWithDots" :key="index" v-bind:class="[current === num ? 'active' : '']">
      <span v-if="num !== '...'">
        <router-link :to="{ name: routeName, params: { query }, query: { paged: num } }">{{ num }}</router-link>
      </span>
      <span v-if="num === '...'">
        <a href="#" class="disabled">{{ num }}</a>
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['current', 'last', 'routeName', 'query'],
  data () {
    return {
      rangeWithDots: []
    }
  },
  created () {
    this.getPagination(this.current, this.last)
  },
  methods: {
    getPagination (c, m) {
      const current = c
      const last = m
      const delta = 2
      const left = current - delta
      const right = current + delta + 1
      const range = []
      let l

      for (let i = 1; i <= last; i++) {
        if ((i === 1 || i === last) || (i >= left && i < right)) {
          range.push(i)
        }
      }

      for (const i of range) {
        if (l) {
          if (i - l === 2) {
            this.rangeWithDots.push(l + 1)
          } else if (i - l !== 1) {
            this.rangeWithDots.push('...')
          }
        }
        this.rangeWithDots.push(i)
        l = i
      }
    }
  }
}
</script>
